<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Cartera de Cheques de Terceros">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="chequesTerceros" 
              :fields="chequesTercerosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaEmision)="data">
              {{ data.item.fechaEmision | fecha }}
            </template>
            <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
            </template>
            <template v-slot:cell(numero)="data">
              <template v-if="!data.item.sinNumero" >
                {{ data.item.numero }}
              </template>
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editarCheque(data.item)">
                  <i class="fa fa-edit"></i>Editar Cheque</b-dropdown-item>
                <b-dropdown-item
                    :disabled="data.item.sinNumero" 
                    @click.stop="depositarCheque(data.item)">
                  <i class="fa fa-university"></i>Depositar Cheque</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              @click.stop="exportCarteraXls">
            <i class="fa fa-file-excel-o"></i>Exportar Cartera de Cheques</b-dropdown-item>

          <b-dropdown-item
              @click.stop="exportCarteraAFechaXls">
            <i class="fa fa-file-excel-o"></i>Exportar Cartera de Cheques a Fecha</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    
    <b-modal ref="depositarChequeModal" 
        title="Deposito de Cheques"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-deposito
        :chequeTerceroId="chequeSeleccionadoId"
        @chequeDepositado="chequeDepositado"
        @cancel="depositoCancelado">
      </app-deposito>
    </b-modal>

    <b-modal ref="seleccionFechaModal" 
        title="Consultar Cartera a Fecha"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-seleccion-fecha
        :fechaInicial="fechaConsulta"
        @fechaSeleccionada="fechaConsultaSeleccionada"
        @seleccionFechaCancelada="seleccionFechaConsultaCancelada">
      </app-seleccion-fecha>
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import DepositoBanco from './DepositoBanco.vue';
import SeleccionFecha from  '../shared/seleccionFecha.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'chequesterceros/getField',
  mutationType: 'chequesterceros/updateField',
});

export default {
  name: 'ChequesTerceros',
  components: {
    appDeposito: DepositoBanco,
    appSeleccionFecha: SeleccionFecha,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      chequesTercerosFields: [
        { key: 'fechaEmision' },
        { key: 'fechaPago' },
        { key: 'cliente' },
        { key: 'titular' },
        { key: 'titularCuit' },
        { key: 'banco' },
        { key: 'serie' },
        {
          key: 'numero',
          class: 'text-right',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
        /*
        {
          key: 'caja',
          class:'text-center'
        },
        */
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,

      chequeSeleccionadoId: 0,
      fechaConsultaCartera: new Date()
    }
  },
  computed: {
    ...mapFields([
      'chequesTerceros',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
    ]),
    fechaConsulta() {
      return moment(this.fechaConsultaCartera).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getChequesTerceros();
  },  
  methods: {
    getChequesTerceros() {
      this.tableBusy = true;
      this.$store.dispatch('chequesterceros/getChequesTerceros')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'ChequeTerceroData', 
                          params: { id: item.id }})
    },
    editarCheque (item) {
      this.$router.push({ name: 'ChequeTerceroEdit', 
                          params: { id: item.id }});
    },
    // agregar () {
    //   this.$router.push({ name: 'ChequeTerceroAdd' });
    // },

    depositarCheque(item){
      this.chequeSeleccionadoId = item.id;

      this.$refs.depositarChequeModal.show();
    },
    chequeDepositado(){
      this.$refs.depositarChequeModal.hide();
      this.getChequesTerceros();

      this.showModalMsj('El depósito se registró con éxito.', null, null, 'light');
    },
    depositoCancelado(){
      this.$refs.depositarChequeModal.hide();
    },
    exportCarteraXls () {
      this.showSpinner();
      this.$store.dispatch('chequesterceros/getRptChequesTerceros')      
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptChequesTerceros = this.$store.getters['chequesterceros/rptChequesTerceros'];

          if (rptChequesTerceros) {
            if (rptChequesTerceros.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportarChequesTercerosXls({
              rptChequesTerceros,
              carteraAFecha: false
            });
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportCarteraAFechaXls () {
      this.$refs.seleccionFechaModal.show();
    },
    fechaConsultaSeleccionada(fecha) {
      this.$refs.seleccionFechaModal.hide();
      this.fechaConsultaCartera = fecha;

      this.showSpinner();
      this.$store.dispatch('chequesterceros/getRptChequesTercerosAFecha', fecha)      
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptChequesTerceros = this.$store.getters['chequesterceros/rptChequesTerceros'];

          if (rptChequesTerceros) {
            if (rptChequesTerceros.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportarChequesTercerosXls({
              rptChequesTerceros,
              carteraAFecha: true
            });
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    seleccionFechaConsultaCancelada() {
      this.$refs.seleccionFechaModal.hide();
    },
    exportarChequesTercerosXls (params) {
      let title= 'Cartera de Cheques';
      let fileName = 'cheques-terceros';

      let format = [];

      if (params.carteraAFecha) {
        format.push(
          { titulo: 'Fecha Ingreso', nombre: 'fechaRegistro', formato: 'fecha' }
        )
      }

      format.push(
        { titulo: 'Fecha Emisión', nombre: 'fechaEmision', formato: 'fecha' },
        { titulo: 'Fecha Pago', nombre: 'fechaPago', formato: 'fecha' },
        { titulo: 'Cliente', nombre: 'cliente', formato: '' },
        { titulo: 'Titular', nombre: 'titular', formato: '' },
        { titulo: 'Cuit', nombre: 'titularCuit', formato: '' },
        { titulo: 'Banco', nombre: 'banco', formato: '' },
        { titulo: 'Serie', nombre: 'serie', formato: '' },
        { titulo: 'Número', nombre: 'numero', formato: '' },
        { titulo: 'Importe', nombre: 'importe', formato: 'moneda' }
      )

      if (params.carteraAFecha) {
        format.push(
          { titulo: 'Fecha Acredit.', nombre: 'fechaAcreditacion', formato: 'fecha' },
          { titulo: 'Cuenta Acredit.', nombre: 'cuentaAcreditacion', formato: '' }
        )
      }

      this.exportXLS(title, fileName, params.rptChequesTerceros, format);
    },

  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getChequesTerceros(); 
      }
    },    
  }    
}
</script>

<style>
</style>
